import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

Sentry.init({
  dsn: 'https://6b7be6fa5eb2e1f12b90734230dd2b8f@o4511540351991808.ingest.de.sentry.io/4511540499120208',
  environment: process.env.NODE_ENV,
  enableLogs: true,
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  tracesSampleRate: 0,
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Analytics />
    <SpeedInsights />
    <App />
  </React.StrictMode>
);

reportWebVitals();